import $axios from "../../api/axios";

function getDueLstApi({ params, callback }) {
  $axios
    .get(`/api/invoice/due/0/9999999999/${params.page}/${params.pageSize}`)
    .then(res => {
      if (params.type && params.type == 1) callback(res, 1);
      else callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getPassLstApi({ params, callback }) {
  $axios
    .get(`/api/invoice/past/0/9999999999/${params.page}/${params.pageSize}`)
    .then(res => {
      if (params.type && params.type == 1) callback(res, 1);
      else callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getPdfLstApi({ params, callback }) {
  $axios
    .get(`/api/invoice/receipts/0/9999999999/${params.page}/${params.pageSize}`)
    .then(res => {
      if (params.type && params.type == 1) callback(res, 1);
      else callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function markApi({ params, callback }) {
  $axios
    .put(`/api/invoice/done/${params}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getDueLstApi,
  getPassLstApi,
  markApi,
  getPdfLstApi
};



// WEBPACK FOOTER //
// ./src/api/account/invoice.js